/**
 * Component for displaying a single achievement
 */

import React from "react";

function romanize(num) {
  if (isNaN(num)) return NaN;
  var digits = String(+num).split(""),
    key = [
      "",
      "C",
      "CC",
      "CCC",
      "CD",
      "D",
      "DC",
      "DCC",
      "DCCC",
      "CM",
      "",
      "X",
      "XX",
      "XXX",
      "XL",
      "L",
      "LX",
      "LXX",
      "LXXX",
      "XC",
      "",
      "I",
      "II",
      "III",
      "IV",
      "V",
      "VI",
      "VII",
      "VIII",
      "IX",
    ],
    roman = "",
    i = 3;
  while (i--) roman = (key[+digits.pop() + i * 10] || "") + roman;
  return Array(+digits.join("") + 1).join("M") + roman;
}

const AchievementContainer = ({ achievement }) => {
  let level = achievement.level;
  let level_class = "";

  if (achievement.type === "cupWIN" || achievement.type === "nationalsWIN") {
    level = achievement.level.toString().slice(-2);
  } else if (
    achievement.type === "goallead" ||
    achievement.type === "bigshot" ||
    achievement.type === "pointlead" ||
    achievement.type === "pimlead" ||
    achievement.type === "productionline" ||
    achievement.type === "brickwall"
  ) {
    level = achievement.level.toString().slice(-2);
  } else if (achievement.level === 0) {
    level = "★";
    level_class = "star";
  } else {
    level = romanize(achievement.level);
  }

  return (
    <div
      key={achievement}
      className="flex flex-col justify-start items-center pt-2 w-24 sm:w-28 md:w-32 m-0.5 xs:m-1 mb-2 xs:mx-2 xs:my-2 rounded xs:p-1"
    >
      <div className="relative w-full overflow-hidden flex justify-center items-start">
        <div className="achievementParent object-cover">
          <img
            src={"/assets/icons/" + achievement.class + ".png"}
            alt={achievement.title}
          />
          <img
            src={"/assets/icons/" + achievement.type + ".png"}
            alt={achievement.title}
          />
          <div className={level_class}>{level}</div>
        </div>
      </div>
      <div className="flex flex-col justify-start items-center flex-grow mt-1">
        <p className="text-xxs leading-tight font-semibold text-center mb-0.5 xs:mb-2">
          {achievement.title}
        </p>
        <p className="text-xxxs  text-darken leading-tight text-center">
          {achievement.description}
        </p>
      </div>
    </div>
  );
};

export default AchievementContainer;
